import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/Button';
import { BookingModal } from './BookingModal';
export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [isBookingModalOpen, setIsBookingModalOpen] = useState(false);
  const location = useLocation();
  const navLinks = [{
    name: 'Home',
    path: '/'
  }, {
    name: 'Collections',
    path: '/collections'
  }, {
    name: 'Kochi Guide',
    path: '/kochi-guide'
  }];
  const isActive = (path: string) => location.pathname === path;
  return <>
      <header className="sticky top-0 z-50 w-full bg-gradient-to-r from-white via-emerald-50/80 to-lime-50/80 backdrop-blur-md border-b border-emerald-200/50 shadow-sm" data-id="element-86">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-87">
          <div className="flex justify-between items-center h-24" data-id="element-88">
            {/* Logo */}
            <Link to="/" className="flex items-center space-x-3" data-id="element-89">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/p7F7UJfUdiT9HJFSan1U4Z/Oshara_Collective_Logo.png" alt="Oshara Collective" className="h-16 md:h-20 w-auto" data-id="element-90" />
            </Link>

            {/* Desktop Navigation */}
            <nav className="hidden md:flex items-center space-x-8" data-id="element-91">
              {navLinks.map(link => <Link key={link.path} to={link.path} className={`text-sm font-medium transition-colors hover:text-emerald-700 ${isActive(link.path) ? 'text-emerald-700 font-bold' : 'text-emerald-600'}`} data-id="element-92">
                  {link.name}
                </Link>)}
              <Button size="sm" className="bg-gradient-to-r from-amber-400 to-amber-500 hover:from-amber-500 hover:to-amber-600 text-emerald-900 border-none font-bold shadow-md" onClick={() => setIsBookingModalOpen(true)} data-id="element-93">
                Enquire Now
              </Button>
            </nav>

            {/* Mobile Menu Button */}
            <div className="md:hidden" data-id="element-94">
              <button onClick={() => setIsOpen(!isOpen)} className="text-emerald-700 hover:text-emerald-800 p-2" aria-label="Toggle menu" data-id="element-95">
                {isOpen ? <X className="h-6 w-6" data-id="element-96" /> : <Menu className="h-6 w-6" data-id="element-97" />}
              </button>
            </div>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isOpen && <div className="md:hidden bg-gradient-to-b from-emerald-50 to-lime-50 border-b border-emerald-200" data-id="element-98">
            <div className="px-4 pt-2 pb-6 space-y-2" data-id="element-99">
              {navLinks.map(link => <Link key={link.path} to={link.path} onClick={() => setIsOpen(false)} className={`block px-3 py-3 rounded-md text-base font-medium ${isActive(link.path) ? 'bg-emerald-100 text-emerald-800 font-bold' : 'text-emerald-700 hover:bg-emerald-50 hover:text-emerald-800'}`} data-id="element-100">
                  {link.name}
                </Link>)}
              <div className="pt-4" data-id="element-101">
                <Button className="w-full bg-gradient-to-r from-amber-400 to-amber-500 hover:from-amber-500 hover:to-amber-600 text-emerald-900 border-none font-bold" size="lg" onClick={() => {
              setIsOpen(false);
              setIsBookingModalOpen(true);
            }} data-id="element-102">
                  Enquire Now
                </Button>
              </div>
            </div>
          </div>}
      </header>

      <BookingModal isOpen={isBookingModalOpen} onClose={() => setIsBookingModalOpen(false)} data-id="element-103" />
    </>;
}